import AcSwipe from 'ac-components/ac-swiper';
import classnames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC, useEffect, useMemo, useState } from 'react';
import styles from './styles.scss';



const TutorsSection: FC = () => {
	const { width } = useResizeObserver()
	const [titleRender, setTitleRender] = useState<any>();
	const { transData, local, list } = useTranslation('oneOnOne.tutors')
	const listRender = useMemo(() => {
		if (!Array.isArray(list)) return []
		return list.map((item, index) => {
			return (
				<a
					key={index}
					href="https://www.trustpilot.com/review/air-class.com">
					<div
						className={classnames(styles['li-item'], styles['li-item-' + item.id])}
						style={{
							backgroundImage: `url(${item.icon}),url(https://web-data.zmlearn.com/image/97QgciB1412CM4U5ZY1HfQ/img_P3_arrow%402x.png)`,
						}}
					>
						<div className={styles['content-top']} >
							<h4>{item.top.title}</h4>
							<span>{item.top.content}</span>
							<div className={styles['rating-start']}>
								{Array.from({ length: 5 }).map((_, i) => {
									return (
										<img loading='lazy' src='https://web-data.zmlearn.com/image/jmp7nFSKojPMKHbDCYvnH1/icon_star_light%402x.png' alt="" key={i} />
									)
								})}
							</div>
							<img src={item.img} alt="" loading='lazy' />
						</div>
						<div className={styles['content-bottom']} >
							{
								item.bottom.map((bot: { icon: string | undefined; content: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined }, index: React.Key | undefined) => {
									return (
										<div
											key={index}
											className={styles['bottom-item']}
										>
											<img loading='lazy' src={bot.icon} alt="" />
											<span>{bot.content}</span>
										</div>
									)
								})
							}
						</div>
					</div>
				</a>
			)
		})
	}, [list])

	// useEffect(() => {
	// 	if (width < 768) {
	// 		list.push(list.splice(1, 1)[0])
	// 		setList(list);
	// 	}
	// }, [width])

	useEffect(() => {
		if (list.length > 0) {
			setTitleRender(
				list.map((item, index) => {
					return (
						<div
							key={index}
							className={styles['title-item']}
						>
							<img loading='lazy' src={item.titleIcon} alt="" />
							<div className={styles['title-item-desc']} dangerouslySetInnerHTML={{ __html: item.title }} />
						</div>
					)
				}
				)
			)
		}
		return () => {
			setTitleRender(null)
		}
	}, [list])

	return (
		<section className={styles['ac-1on1-tutors']}>
			<div className={styles['ac-1on1-tutors-container']}>
				<img className={styles['ac-1on1-tutors-img-1']} loading='lazy' src="https://web-data.zmlearn.com/image/v1km5krZo749H9WPg2C5ci/img_P3_left%402x.png" alt="" />
				{width > 1800 &&
					<img className={styles['ac-1on1-tutors-img-2']} loading='lazy' src={'https://web-data.zmlearn.com/image/5vRsUQFdrTqZHwp7LQMu27/img_p3_right%402x.png'} alt="" />}
				{width < 1192 &&
					<img className={styles['ac-1on1-tutors-img-2']} loading='lazy' src={'https://web-data.zmlearn.com/image/7K26VB86YMASQz9qUYgoYq/img_p3_right%E5%A4%87%E4%BB%BD%402x.png'} alt="" />
				}
				<div className={styles[`title-${local}`]} dangerouslySetInnerHTML={{ __html: transData.title }} />
				<div className={classnames(styles['ac-1on1-tutors-title'], 'ac-1on1-tutors-title')}
				>{titleRender}</div>
				<AcSwipe className={classnames(styles['ac-1on1-tutors-banner'], 'ac-1on1-tutors-banner')}
					loop={width < 1192}
					spaceBetween={width >= 1192 ? 24 : 16}
					pagination={{ clickable: true }}
					autoplay={width < 1192}
					slidesPerView={width >= 1192 ? 3 : 'auto'}
				>{listRender}</AcSwipe>
			</div>
		</section >
	);
}

export default TutorsSection
